<script lang="ts" setup>
import { BPTQuestion } from '@/models/bpt.model';
import { PropType } from 'vue';
import { useStore } from 'vuex';
import { ShiftCMSState } from '@/store';
import { BPTStoreActions, BPTStoreState } from '@/stores/bpt.store';
import SortItems from '@/components/common/SortItems.vue';

const props = defineProps({
  data: {
    type: Array as PropType<BPTQuestion[]>,
    required: true,
  },
});

const store = useStore<ShiftCMSState & { bpt: BPTStoreState }>();

const save = (v: number[]) => {
  store.dispatch(BPTStoreActions.UpdateQuestionOrder, v);
};
</script>
<template>
  <v-container>
    <h2>Sort Questions</h2>
    <v-alert type="info"
      >Sort the items in the order of which the questions will be
      presented.</v-alert
    >
    <SortItems
      :items="[...props.data]"
      @change="save"
      :order="
        [...props.data].sort((a, b) => a.index - b.index).map((s) => s.id)
      "
    />
  </v-container>
</template>
<style scoped>
.draglist {
  list-style-type: square;
}

.item {
  display: flex;
  flex-direction: row;
}
.name {
  width: 300px;
  cursor: grab;
}
.drop-target {
  width: 200px;
  height: 24px;
  border: dashed 1px black;
  border-radius: 4px;
  border-color: rgb(0, 0, 0);
}
.drop-target.drag-active {
  border-color: rgba(46, 126, 246, 1);
  background-color: rgba(46, 126, 246, 0.5);
}
</style>
